// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","spaceFluid":"100%","rsvpButtons":"rsvp-flow__rsvpButtons___ECljw"};